export default __webpack_public_path__ + "static/media/partner-mb.e6c292c6.webp";